import { PaginatedResponse } from '@/types/responses';
import { EVENTS_PAGE_SIZE, PaginatedEventsResult } from './eventsDataShared';
import { usePaginatedList } from './usePaginatedList';

interface PaginatedQuery<T> {
    cacheKey: string;
    pageStateKey?: string;
    fetchPage: (pageIndex: number) => Promise<PaginatedResponse<T>>;
}

export function usePaginatedQueryResult<T>({
    cacheKey,
    pageStateKey,
    fetchPage,
}: PaginatedQuery<T>): PaginatedEventsResult<T> {
    const result = usePaginatedList<T>({
        cacheKey,
        pageSize: EVENTS_PAGE_SIZE,
        fetchPage,
    });
    return { ...result, pageStateKey };
}
